<template>
<body class="A4">
  <report-sheet-defect
    :source="source"
    :pole="pole"
    :poleModel="poleModel"
    :filters="filters"
    :voltage="voltage"
    :load="load"
    :humidity="humidity"
    :temperature="temperature"
    :redisRoute="redisRoute"
    sheetType="defect"
    @defectVerified="defectVerified"
    @isLoading="isLoading"
    @toggleModal="toggleModal"
  />
  <report-sheet-overview
    v-if="filters.type == 'Full'"
    :source="source"
    :pole="pole"
    :filters="filters"
    :voltage="voltage"
    :load="load"
    :humidity="humidity"
    :temperature="temperature"
    sheetType="visual"
    @toggleModal="toggleModal"
  />
  <report-sheet-overview
    v-if="filters.type == 'Full'"
    :source="source"
    :pole="pole"
    :filters="filters"
    :voltage="voltage"
    :load="load"
    :humidity="humidity"
    :temperature="temperature"
    sheetType="thermal"
    @toggleModal="toggleModal"
  />
</body>
</template>

<script>
import API from "@/api.js";
import ReportSheetDefect from "@/components/ReportSheetDefect";
import ReportSheetOverview from "@/components/ReportSheetOverview";

export default {
  name: "reportViewer",
  props: [
    "source",
    "pole",
    "poleModel",
    "filters",
    "voltage",
    "load",
    "temperature",
    "humidity",
    "redisRoute",
  ],
  components: {
    "report-sheet-defect": ReportSheetDefect,
    "report-sheet-overview": ReportSheetOverview,
  },
  methods: {
    isLoading(show) {
      this.$emit("isLoading", show);
    },
    defectVerified(e) {
      this.$emit("defectVerified", e);
    },
    toggleModal(name, show, images, index, caption) {
      this.$emit("toggleModal", name, show, images, index, caption);
    },
  },
};
</script>

<style>
@page {
  size: A4;
}

body.A4 {
  background-color: #f5f7fa;
}
</style>
